export default __webpack_public_path__ + "static/media/calendar.d08903b5.svg";